import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import {GlobalConfig} from "./Services/Helper/GlobalConfig";
import IdleTimer from 'react-idle-timer'
import { Provider } from "react-redux";
import store from "./Services/store";
const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
// import {AppSidebarNav2 as AppSidebarNav} from "@coreui/react";
// import navigationAdmin from "./_navAdmin";
// import * as router from "react-router-dom";
// import navigationClient from "./_navClient";
// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));
const AdminLayout = React.lazy(() => import('./containers/AdminLayout'));
const ClientLayout = React.lazy(() => import('./containers/ClientLayout'));
const BaseLayout = React.lazy(() => import('./containers/BaseLayout'));


// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Register = React.lazy(() => import('./views/Pages/Register'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.state = {
      isAdmin: GlobalConfig.isAdmin,
      isBaseUser: GlobalConfig.isBaseUser,
      alert: null
    };

  }
  _onAction(e) {
    console.log('user did something', e)
  }

  _onActive(e) {
    console.log('user is active', e)
    console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  _onIdle(e) {
    console.log('user is idle', e)
    if(window.location.pathname.indexOf("login") < 0){
      window.location = "/login"
    }

  }
  changeIsAdmin = (isAdmin,isBaseUser,props) =>{
    console.log("[changeIsAdmin Props]",props)
    // alert("admin - "+GlobalConfig.isAdmin)
    // alert("isBaseUser - "+GlobalConfig.isBaseUser)
    // alert(GlobalConfig.allowDashboard)

    this.setState({
      isAdmin: isAdmin
    },()=>{
      if(GlobalConfig.isAdmin)
        props.history.push("/dashboard");
      else if(GlobalConfig.isBaseUser && GlobalConfig.allowDashboard)
        props.history.push("/hub");
      else if(GlobalConfig.isBaseUser)
        props.history.push("/base-customers");
      else
        props.history.push("/home");
    });
  }
  render() {
    return (
        <>
            <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                element={document}
                onIdle={this.onIdle}
                timeout={1000 * 60 * 15} />
              <BrowserRouter>
                  <React.Suspense fallback={loading()}>
                    <Switch>
                      <Route exact path="/login" name="Login Page" render={props => <Login {...props} changeIsAdmin={this.changeIsAdmin}/>} />
                      <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
                      <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
                      <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
                      {GlobalConfig.isAdmin ?
                          <Route path="/" name="Home" render={props => <AdminLayout {...props}/>} /> :
                          GlobalConfig.isBaseUser?
                           <Route path="/" name="Home" render={props => <BaseLayout {...props}/>} />:
                          <Route path="/" name="Home" render={props => <ClientLayout {...props}/>} />
                      }

                    </Switch>
                  </React.Suspense>
              </BrowserRouter>
          </>
    );
  }
}
const mapStateToProps = state => ({

});

export default App;
